/*
const form__yes = document.getElementById("form__yes")
const form__no = document.getElementById("form__no")
const yes = document.getElementById("yes")
const no = document.getElementById("no")


if (yes && no) {
  yes.addEventListener("click", () => {
    form__yes.style.display = "block"
    form__no.style.display = "none"
  })

  no.addEventListener("click", () => {
    form__yes.style.display = "none"
    form__no.style.display = "block"
  })
}

// Провекра инпута с кодом на наличие символов

const $code = $("[data-form=code]")
const $button = $("[data-form=submit]")
let codeIn
let codeLength

const stopSubmit = () => {
  $code.on("propertychange input", (event) => {
    codeIn = $(event.currentTarget)
    codeLength = codeIn.val().length

    if (codeLength >= 3) {
      $button.attr("disabled", false)
    } else {
      $button.attr("disabled", true)
    }
  })
}

stopSubmit()
*/



// WEBPACK FOOTER //
// ./src/blocks/sms-form/inputs.js